import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { HiOutlineCheckCircle } from "react-icons/hi2";

import { ActionButtons } from "./ActionButtons";
import { VideoThumbnail } from "./VideoThumbnail";

type UploadedContentProps = {
  fileName: string;
  fileType: string;
  metaText?: string;
  mediaUrl?: string;
  readOnly?: boolean;
  isRemoving?: boolean;
  onPlay?: () => void;
  onRemove?: () => void;
};

export const UploadedContent: React.FC<UploadedContentProps> = ({
  fileName,
  fileType,
  metaText,
  mediaUrl,
  readOnly,
  isRemoving,
  onPlay,
  onRemove,
}) => (
  <HStack justify="space-between" spacing={6} align="center" width="100%">
    <Box
      bg="green.50"
      outline="1px solid"
      outlineColor="green.500"
      borderRadius="6px"
      p={2}
      m={-2}
      flex="1"
      minW={0}
    >
      <HStack spacing={4} align="center" flex="1" minW={0}>
        <VideoThumbnail mediaUrl={mediaUrl || ""} format={fileType} />
        <VStack align="start" spacing={1} flex="1" minW={0}>
          <Box maxW="100%" overflow="hidden">
            <Text
              fontSize="sm"
              fontWeight="semibold"
              color="gray.900"
              lineHeight={5}
              display="inline"
              noOfLines={1}
            >
              {fileName}
              {metaText && (
                <Text as="span" fontWeight="normal" color="gray.600">
                  {" "}
                  • {metaText}
                </Text>
              )}
            </Text>
          </Box>
          <HStack spacing={2} py={1}>
            <Icon as={HiOutlineCheckCircle} boxSize={5} color="green.500" />
            <Text fontSize="sm" color="green.600" lineHeight={5}>
              Uploaded
            </Text>
          </HStack>
        </VStack>
      </HStack>
    </Box>
    {!readOnly && (
      <ActionButtons
        playEnabled={!!mediaUrl}
        removeEnabled
        isRemoving={isRemoving}
        onPlay={onPlay}
        onRemove={onRemove}
      />
    )}
  </HStack>
);
